import Icon from '../icons';

const clockIcon = Icon({ type: 'clock', color: '#848d9e', size: 16 });

class Homescreen {
  constructor() {
    this.getText = Pollfish.ui.getText;
  }

  renderHeader = () => {
    const { getText } = this;
    const surveyLOI = this.getSurveyLOI();

    return getText('surveyPromptNoIncentive', surveyLOI);
  };

  getSurveyLOI = () => {
    const { survey_loi: surveyLOI } = Pollfish.helper.json;

    // Only show LOI when the backend provides it
    return surveyLOI;
  };

  renderImg = () => {
    // incentive was the amazon gift cards that have been deprecated
    let type = 'non-incentive';

    let imgEl = `
      <div class="card__image card__image--no-margin card__image--${type}">
        <div class="card__image-svg card__image-svg--${type}"></div>
      </div>
    `;

    if (
      (!Pollfish.helper.whiteLabelEnabled() ||
        Pollfish.helper.hasCustomSurveyTheme()) &&
      Pollfish.helper.json.theme_logo
    ) {
      type = 'custom-logo';
      imgEl = `
        <div class="card__image card__image--no-margin card__image--${type}">
          <img src="${Pollfish.helper.json.theme_logo}" alt="" style="max-height: 160px; max-width: 100%;" />
        </div>
      `;
    }

    return imgEl;
  };

  renderLOI = () => {
    const surveyLOI = this.getSurveyLOI();
    if (!surveyLOI) {
      return '';
    }
    return `
        <p class="flex flex-align-items--center flex-1 flex-justify--center">
          <span class="line-height-reset">${clockIcon}</span>
          <span class="font-bold" style="margin-left: 3px;">${surveyLOI}'</span>
        </p>
    `;
  };

  renderAcceptanceInfo = () => {
    const { getText } = this;
    let text = getText('by_accepting_this_survey');
    if (Pollfish.helper.isAndroid() && Pollfish.helper.json.sdk_version < 34) {
      text = getText('android_notification');
    }
    const content = `
      <p class="text-xs text-light google-indicator margin-xl-btm">
        ${text}
      </p>
    `;

    return content;
  };

  renderWithdrawConsent = () => {
    let content = '';
    const { getText } = this;
    if (Pollfish.helper.isDistributionLink()) {
      return content;
    }

    if (Pollfish.helper.hasAcceptedTerms()) {
      content = `
        <span class="horizontal-separator">/</span>
        <a href="#" class="js-withdraw-consent link-theme-hover link-with-light-underline">${getText(
          'withdraw_consent',
        )}</a>
      `;
    }

    return content;
  };

  renderNoThanks = () => {
    const { getText } = this;
    return `
      <div class="margin-xl-top">
        <a href="#" class="btn btn-xs btn-flat js-survey-reject-btn link-theme-hover">
          ${getText('no_thanks')}
        </a>
      </div>
    `;
  };

  renderTerms = () => {
    const { getText } = this;
    const text = getText('by_taking_survey');
    return `${text} <a href="#" class="js-terms link-theme-hover link-with-light-underline">${getText(
      'notify_terms',
    )}</a>`;
  };

  render() {
    const { getText } = this;
    const surveyLOI = this.renderLOI();
    const loiMarkup = surveyLOI
      ? `<div class="margin-lg-top">${surveyLOI}</div>`
      : '';
    const startSurveyMargin = surveyLOI ? 'margin-lg-top' : 'margin-xl-top';

    return `
      <div class="main-content__home">
        <h1 class="header-text">${this.renderHeader()}</h1>
        <div class="homescreen-card">
          <div class="card__header">
            ${this.renderImg()}
          </div>
          <div class="card__content">
            ${loiMarkup}
            <div class="${startSurveyMargin}">
              <a href="#" id="take-survey-btn" class="btn btn-primary btn-lg js-take-survey-btn">
                ${getText('take_survey_btn')}
              </a>
            </div>
            <div class="text-sm text-light margin-xl-top opens-in-browser font-bold">
              ${getText('anonymous_responses')}
            </div>
            ${this.renderAcceptanceInfo()}
          </div>
        </div>
        ${Pollfish.helper.shouldHideNoThanks() ? '' : this.renderNoThanks()}
      </div>
      <div class="footer">
        <p class="text-sm text-light footer__terms">
          ${this.renderTerms()}
          ${this.renderWithdrawConsent()}
        </p>
      </div>`;
  }
}

export default Homescreen;
